import { useEffect, useState } from "react";

const computeViewportWidth = () => {
  if (typeof window === "undefined") return 0;
  return window.innerWidth;
};

/**
 * Hook to track the viewport width and update on resize/orientation change.
 * Returns the current window inner width in pixels.
 *
 * @returns Current viewport width in pixels
 *
 * @example
 * ```tsx
 * const width = useViewportWidth();
 * <div style={{ width: `${width}px` }}>Content</div>
 * ```
 */
export function useViewportWidth() {
  const [width, setWidth] = useState<number>(computeViewportWidth());

  useEffect(() => {
    const handleResize = () => setWidth(computeViewportWidth());
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  return width;
}
